import { z } from '@hono/zod-openapi'

export const LaneIdSchema = z.enum(['mtss', 'sped', 's504', 'el', 'health']).openapi({
  example: 'sped',
  description: 'The five service lanes',
})

export const StudentStatusSchema = z.enum(['active', 'inactive', 'transferred', 'graduated']).openapi({
  example: 'active',
})

export const StudentSchema = z.object({
  id: z.string().uuid().openapi({ example: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890' }),
  districtId: z.string().min(1).max(64).openapi({ example: 'dist-wa-12345' }),
  schoolId: z.string().min(1).max(64).nullable().openapi({ example: 'sch-67890' }),
  firstName: z.string().min(1).max(100).openapi({ example: 'Jane' }),
  lastName: z.string().min(1).max(100).openapi({ example: 'Doe' }),
  middleName: z.string().max(100).nullable().openapi({ example: 'M' }),
  dob: z.string().date().openapi({ example: '2010-05-15' }),
  grade: z.number().int().min(0).max(12).nullable().openapi({ example: 5 }),
  lane: LaneIdSchema,
  status: StudentStatusSchema,
  externalId: z.string().max(255).nullable().openapi({ example: 'SIS-100234' }),
  stateStudentId: z.string().max(64).nullable().openapi({ example: 'WA-987654321' }),
  raceEthnicity: z.string().max(64).nullable().openapi({ example: 'Hispanic/Latino' }),
  frlStatus: z.enum(['free', 'reduced', 'paid', 'unknown']).nullable().openapi({ example: 'free' }),
  ellStatus: z.boolean().nullable().openapi({ example: true }),
  iepStatus: z.boolean().nullable().openapi({ example: false }),
  s504Status: z.boolean().nullable().openapi({ example: false }),
  healthPlanStatus: z.boolean().nullable().openapi({ example: false }),
  createdAt: z.string().datetime().openapi({ example: '2025-09-01T00:00:00Z' }),
  updatedAt: z.string().datetime().openapi({ example: '2026-07-15T12:00:00Z' }),
}).openapi('Student', { description: 'A student record in the district' })

export const StudentCreateSchema = StudentSchema.omit({ id: true, createdAt: true, updatedAt: true }).openapi('StudentCreate', {  })
export const StudentUpdateSchema = StudentSchema.partial().omit({ id: true, districtId: true, createdAt: true, updatedAt: true }).openapi('StudentUpdate', {  })

export const StudentListSchema = z.object({
  data: z.array(StudentSchema),
  total: z.number().int().openapi({ example: 142 }),
  page: z.number().int().openapi({ example: 1 }),
  pageSize: z.number().int().openapi({ example: 50 }),
}).openapi('StudentList')

export type LaneId = z.infer<typeof LaneIdSchema>
export type StudentStatus = z.infer<typeof StudentStatusSchema>
export type Student = z.infer<typeof StudentSchema>
export type StudentCreate = z.infer<typeof StudentCreateSchema>
export type StudentUpdate = z.infer<typeof StudentUpdateSchema>
